// DS i3.43
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const CreateFolder: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.16667 5C5.12804 5 3.51364 6.64062 3.51333 8.66608L3.5 21.3333C3.5 23.3656 5.13438 25 7.16667 25H14.5C15.0523 25 15.5 24.5523 15.5 24C15.5 23.4477 15.0523 23 14.5 23H7.16667C6.23911 23 5.50026 22.2608 5.5 21.3333L5.51333 8.66667C5.51333 7.73239 6.24549 7 7.16667 7H12.4191L15.0858 9.66667H23.8333C24.761 9.66667 25.5 10.4056 25.5 11.3333V14.0335C25.5 14.5858 25.9477 15.0335 26.5 15.0335C27.0523 15.0335 27.5 14.5858 27.5 14.0335V11.3333C27.5 9.30105 25.8656 7.66667 23.8333 7.66667H15.9142L13.2475 5H7.16667Z" />
      <path d="M24.5 18C24.5 17.4477 24.0523 17 23.5 17C22.9477 17 22.5 17.4477 22.5 18V21H19.5C18.9477 21 18.5 21.4477 18.5 22C18.5 22.5523 18.9477 23 19.5 23H22.5V26C22.5 26.5523 22.9477 27 23.5 27C24.0523 27 24.5 26.5523 24.5 26V23H27.5C28.0523 23 28.5 22.5523 28.5 22C28.5 21.4477 28.0523 21 27.5 21H24.5V18Z" />
    </svg>
  </IconWrap>
);
CreateFolder.displayName = 'CreateFolder';

export default CreateFolder;
